import { defineStore } from "pinia";
import http from "@/axios-config";
import isEqual from "lodash/isEqual";

import { getMenu } from "@/functions/Menus";
import { useMenuInfoStore } from "./menu-info";

// This store is used for the current viewed menu
export const useCurrentMenuStore = defineStore("current-menu", {
    state: () => ({
        currentMenu: false,
        tempMenu: false,
        menuItems: [],
        food: [],
        foodTemp: [],
        drink: [],
        drinkTemp: [],
        currentTab: "food",
        hasChanges: false,
    }),
    actions: {
        async getCurrentMenu(slug) {
            await getMenu(slug);
        },
        async saveMenu() {
            this.tempMenu = this.currentMenu;
            this.tempMenu.food = this.food;
            this.tempMenu.drink = this.drink;

            const response = await http.post(
                `/api/menu/${this.currentMenu.slug}/update`,
                { data: this.tempMenu }
            );

            if (response.status === 200) {
                let food = JSON.parse(JSON.stringify(this.food));
                let drink = JSON.parse(JSON.stringify(this.drink));
                let tempMenu = JSON.parse(JSON.stringify(this.tempMenu));

                this.currentMenu = tempMenu;
                this.drinkTemp = drink;
                this.foodTemp = food;
                // Object.assign(this.currentMenu, this.tempMenu);
                // Object.assign(this.foodTemp, this.food);
                // Object.assign(this.drinkTemp, this.drink);
            }
        },

        async addSite(site) {
            site.menu_slug = this.currentMenu.slug;
            this.currentMenu.sites.push(site);
        },

        async removeSite(site) {
            const menuInfoStore = useMenuInfoStore();

            // Find removed site in menu info store
            const index = menuInfoStore.sites.findIndex(
                (s) => s.id === site.id
            );

            if (index > -1) {
                // Remove menu slug from menu info store to keep reactivity
                menuInfoStore.sites[index].menu_slug = null;

                this.currentMenu.sites = this.currentMenu.sites.filter(
                    (s) => s.id !== site.id
                );
            }
        },

        async syncMenus() {
            const response = http.get(
                `/api/menu/${this.currentMenu.slug}/sync`
            );
        },

        async reset() {
            this.food = [];
            this.foodTemp = [];
            this.drink = [];
            this.drinkTemp = [];
            this.currentTab = "food";
        },
    },
    // optional getters
    getters: {
        sortedSites(state) {
            let sorted = state.currentMenu.sites.sort((a, b) =>
                a.name.localeCompare(b.name)
            );

            return sorted;
        },

        hasChanges(state) {
            return (
                !isEqual(this.food, this.foodTemp) ||
                !isEqual(this.drink, this.drinkTemp)
            );
        },

        menuItemsRaw(state) {
            return JSON.parse(JSON.stringify(this.menuItems));
        },
    },
});
